<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="User Types" />
    </template>

    <DxToolbar class="view-toolbar">
      <DxItem
        :options="toolbar.edit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
      />
      <DxItem
        :options="toolbar.save"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode != 'review'"
      />
    </DxToolbar>

    <!-- form  -->
    <div class="view-card responsive-paddings" id="userPanel">
      <!-- <DxLoadPanel
        :position="position"
        :visible.sync="loadingVisible"
        :show-indicator="showIndicator"
        :show-pane="showPane"
        :shading="shading"
        :hide-on-outside-click="hideOnOutsideClick"
        shading-color="rgba(0,0,0,0.4)"
      />-->
      <form>
        <DxForm
          :form-data.sync="model"
          :read-only="false"
          :show-colon-after-label="false"
          :show-required-mark="false"
          :show-validation-summary="false"
          :validation-group="formsConfig.validationGroup"
          :col-count-by-screen="formsConfig.colCountByScreen"
          label-location="left"
          :customizeItem="customizeItem"
          :items.sync="items"
          ref="userForm"
        ></DxForm>
      </form>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../../v1/_mixins/base.view";
// import { DxLoadPanel } from "devextreme-vue/load-panel";
import { DxForm } from "devextreme-vue/form";
import { UserTypeService } from "../../../_services/api/settings/graycorp/user.type.service";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: { DxForm },
  watch: {
    $route: {
      immediate: true,
      handler: "requestApplicationUserTypes",
    },
  },
  data() {
    return {
      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/user-type/edit`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: async (e) => {
            this.$logger.trackEventButtonClickSave();
            const result = await e.validationGroup.validate();
            if (result.isValid) {
              var payload = {
                ApplicationTenantCode: "PROD_DEV",
                ApplicationUserTypeTenants: [],
              };
              // this.$logger.debug("this.model ", this.model);

              for (let index = 0; index < this.payLoadHelper.length; index++) {
                this.payLoadHelper[index].UserCount = this.model[
                  this.payLoadHelper[index].ApplicationUserTypeDisplayName
                ];
                payload.ApplicationUserTypeTenants.push(
                  this.payLoadHelper[index]
                );
              }

              // this.loadingVisible = true;
              this.showLoading(true);
              this.saveUserTypes(payload);
            } else {
              this.displayValidationSummary();
            }
          },
        },
      },
      position: { of: "#userPanel" },
      // loadingVisible: false,
      showIndicator: true,
      shading: true,
      showPane: true,
      hideOnOutsideClick: false,
      items: [
        {
          itemType: "group",
          caption: "",
          items: [],
        },
      ],
      model: {},
      payLoadHelper: [],
    };
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: "/settings/user",
      });
    },
    requestApplicationUserTypes() {
      this.showLoading(true);
      this.getTypes().then((response) => {
        var data = response.data.ApplicationUserTypeTenants;
        this.items[0].items = [];
        this.payLoadHelper = [];
        for (let index = 0; index < data.length; index++) {
          var item = {};
          item.label = {
            text: data[index].ApplicationUserTypeDisplayName,
          };
          item.dataField = data[index].ApplicationUserTypeDisplayName;
          item.editorOptions = {
            editorType: "dxTextBox",
            value: data[index].UserCount,
          };
          item.validationRules = [
            {
              type: "required",
              message: `${data[index].ApplicationUserTypeDisplayName} is required`,
            },
          ];
          this.items[0].items.push(item);
          this.payLoadHelper.push(data[index]);
        }

        let form = this.$refs["userForm"].instance;
        form.repaint();
        this.showLoading(false);
      });
    },
    async getTypes() {
      return await UserTypeService.getCustomRequest({
        url: "api/ApplicationUserTypeManagement",
        expand: "ApplicationUserTypeTenants",
      });
    },
    async saveUserTypes(payload) {
      await UserTypeService.saveUserType(payload)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveUserTypes", response);
          this.$notify("User Types saved successfully", "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/user-type`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "User Types saved Failed");
        });
    },
  },
  created() {
    this.toolbar.edit.visible = this.formsConfig.editableOption;
  },
};
</script>
